@if (!guestDisplay) {
  <div
    data-cy="custom-breadcrumb"
    class="d-flex breadcrumb-custom no-select text-limited-1-line"
    [ngClass]="{ 'full-text-view': fulltextView }"
  >
    <!--If label, then we are in a document view or impacter view-->
    @if (fulltextView) {
      <span [ngbTooltip]="label" tooltipClass="simple-tooltip" [overflowThreshold]="2" overflowTooltip [openDelay]="500"> {{ label }}</span>
    } @else {
      @for (breadcrumb of breadcrumbs; track breadcrumb; let i = $index) {
        <div class="item" [ngClass]="{ 'last-div-item': i === breadcrumbs.length - 1 }">
          <span *ngIf="i === breadcrumbs.length - 1" class="last-item">
            <span>{{ breadcrumb.label | translate }}</span>
            <span class="last-label" *ngIf="label"> | {{ label | translate }}</span>
          </span>
          <span *ngIf="i < breadcrumbs.length - 1">
            <a [routerLink]="['/' + getUrl(breadcrumb.url)]">
              <span>{{ breadcrumb.label | translate }}</span>
              <span *ngIf="i === breadcrumbs.length - 2 && preLabel"> | {{ preLabel | truncate: 50 : '...' }}</span>
            </a>
            <img src="/assets/images/arrow-ios-right.svg" alt="arrow-ios-right" />
          </span>
        </div>
      }
    }
  </div>
}
